import { Box, Link, Section } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import PayrollPaywallGuard from '../../PayrollPaywallGuard'
import ExpensesMappingsTable from './ExpensesMappingsTable'

const ExpensesReimbursementSettings = () => {
  const navigateToLearnMore = () => {
    track(trackingEvents.payroll.learnHowToChangeTitle)
  }

  return (
    <PayrollPaywallGuard>
      <ResponsivePage.Body variant="full" showHeader={false}>
        <Section.FullWidth
          illustration="Replace"
          title={i18n.t(
            'app_store_v2.apps.payroll_bundle.settings.external_supplements.expenses_reimbursement_title'
          )}
          description={i18n.t(
            'app_store_v2.apps.payroll_bundle.settings.external_supplements.expenses_reimbursement_description'
          )}
        >
          <Box gap="s40">
            <ExpensesMappingsTable />
            <Link.Href
              href={helpCenterUrl('payroll_additional_compensations')}
              target="_blank"
              onClick={navigateToLearnMore}
            >
              {i18n.t(
                'app_store_v2.apps.payroll_bundle.settings.external_supplements.learn_to_change_predefined_titles'
              )}
            </Link.Href>
          </Box>
        </Section.FullWidth>
      </ResponsivePage.Body>
    </PayrollPaywallGuard>
  )
}

export default ExpensesReimbursementSettings
